import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App, loadSignedInApp } from "@/app/App";
import { getAuthFlow, mightBeSignedIn } from "@/features/auth/auth-context";
import "@/theme/fonts.css";
import "@/theme/tokens.css";
import "@/theme/base.css";

const root = document.getElementById("root");
if (!root) throw new Error("No #root element in index.html");
// Start the sign-in check now, and for someone who has been in before, the pages too (they start the offline store
// and the outbox). Someone signing in gets the pages while they type (AuthGate).
void getAuthFlow();
if (mightBeSignedIn()) void loadSignedInApp();
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
